import { parseJwt } from '../Helpers/basic';

export const getTenant = () => {
  const tenantConfigs = parseJwt(localStorage.getItem(window.location.origin));
  return tenantConfigs
}